import SmartImage from 'Components/Common/SmartImage';
import { useElementWidth } from 'hooks/useElementWidth';
import React, { useRef } from 'react'
import Skeleton from 'react-loading-skeleton';
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import { Collaboration, SocialPost } from 'types/campaign/collaborations';
import { SocialAccount } from 'types/influencer';
import userDummyImage from "../../assets/images/users/user-dummy-img.jpg"
import { AppDispatch } from 'store';
import { useDispatch } from 'react-redux';
import { showSocialPostModal } from 'slices/ui/reducer';
import InstagramCaption from 'Components/Common/InstagramCaption';
import { formatNumber, getTrimmedText } from 'utils/helpers';
import ReelsIcon from 'assets/icons/ReelsIcon';
import IGStoryIcon from 'assets/icons/mono/IGStoryIcon';
import IGPostIcon from 'assets/icons/mono/IGPostIcon';
import MediaLikesIcon from 'assets/icons/mono/MediaLikesIcon';
import MediaViewsIcon from 'assets/icons/mono/MediaViewsIcon';
import MediaCommentsIcon from 'assets/icons/mono/MediaCommentsIcon';
import { Link } from 'react-router-dom';
const ContentMasonry: React.FC<{ posts: SocialPost[], isLoading: boolean, onAddToCampaignClick?: (post: SocialPost) => void, postCollaborationMap?: Record<string, Collaboration> }> = ({ posts, isLoading, onAddToCampaignClick, postCollaborationMap }) => {

    const wrapperRef = useRef<any>(null);
    const rowWidth = useElementWidth(wrapperRef);
    const dispatch: AppDispatch = useDispatch();

    return (
        <div ref={wrapperRef}>
            <ResponsiveMasonry
                columnsCountBreakPoints={{
                    350: 1,
                    750: 2,
                    900: 3,
                    1200: 4,
                    1500: Math.floor(rowWidth / 230) || 5
                }}
                gutterBreakPoints={{
                    350: '24px',
                }}
            >
                <Masonry>
                    {posts.map((post, i) => (
                        <div key={i} className='masonry-item' id={`masonry-item-${i}`}>
                            <div className="cursor-pointer position-relative masonry-media" onClick={() => {
                                dispatch(showSocialPostModal({ postId: post.uuid, socialAccount: post.social_account! }))
                            }}>
                                <SmartImage key={i} src={post.thumbnail_url} alt={post.posted_on} wrapperClass='explore-item' className='explore-thumb' />
                                <div className="masonry-overlay flex-column justify-content-between align-items-start p-2">
                                    <div>
                                        {
                                            post?.ig_post?.caption &&
                                            <div className="post-card-caption" style={{ marginLeft: '28px', width: 'calc(100% - 28px)' }}>
                                                <InstagramCaption text={getTrimmedText(post?.ig_post?.caption)} />
                                            </div>
                                        }
                                    </div>

                                    <div className="masonry-stats w-100 d-flex align-items-center justify-content-center">
                                        <span className='d-flex align-items-center gap-1'><MediaViewsIcon /> {formatNumber(post.views_count ?? 0)}</span>
                                        <span className='d-flex align-items-center gap-1'><MediaLikesIcon /> {formatNumber(post.likes_count ?? 0)}</span>
                                        <span className='d-flex align-items-center gap-1'><MediaCommentsIcon /> {formatNumber(post.comments_count ?? 0)}</span>
                                    </div>
                                </div>
                                <span className="media-type-icon" style={{ left: '8px', top: '8px' }}>
                                    {
                                        post.type === 'REELS' &&
                                        <ReelsIcon color="#ffffff" />
                                    }
                                    {
                                        post.type === 'STORY' &&
                                        <IGStoryIcon color='#ffffff' />
                                    }
                                    {
                                        post.type === 'VIDEO' &&
                                        <i className="ri-youtube-fill" style={{ fontSize: '24px', color: '#ffffff' }}></i>
                                    }
                                    {
                                        !["REELS", "STORY", "VIDEO"].includes(post.type) &&
                                        <IGPostIcon color='#ffffff' />
                                    }
                                </span>
                            </div>
                            {
                                post.social_account &&
                                <div className="d-flex align-items-center gap-2 mt-2">
                                    {post.social_account?.profile_picture_url ? (
                                        <img src={post.social_account?.profile_picture_url} className="rounded-circle square-30" alt="" />
                                    ) : (
                                        <img src={userDummyImage} className="rounded-circle square-30" alt="" />
                                    )}
                                    <div className="d-flex flex-column gap-0">
                                        <span className='content-masonry-creator-name' >{post.social_account?.name ?? `@${post.social_account?.handle}`}</span>
                                        {
                                            post.social_account.name &&
                                            <span className='content-masonry-creator-handle' >{`@${post.social_account?.handle}`}</span>
                                        }
                                    </div>
                                </div>
                            }
                            {
                                onAddToCampaignClick &&
                                <div className='mt-2'>
                                    {
                                        (postCollaborationMap?.[post.uuid]) ? (
                                            <Link to={{ pathname: `/campaign/${postCollaborationMap[post.uuid].campaign.uuid}/insights` }} target='_blank' className='theme-btn btn-gradient-outline w-100 d-flex align-items-center justify-content-between'> <i className='bx bx-check fs-4'></i> View Campaign <i className='bx bxs-megaphone'></i> </Link>
                                        ) : (
                                            <button className='theme-btn btn-gradient w-100' onClick={() => onAddToCampaignClick(post)}>Track Insights</button>
                                        )
                                    }
                                </div>
                            }
                        </div>
                    ))}
                    {
                        (isLoading) &&
                        Array.from({ length: 10 }).map((_, i) => (
                            <div key={i} className="explore-item w-100">
                                <Skeleton width={`100%`} height={i % 2 === 0 ? 420 : 340} />
                            </div>
                        ))
                    }
                </Masonry>
            </ResponsiveMasonry>
        </div>
    )
}

export default ContentMasonry